import { useEffect } from "react"
import { Card } from "ui/Card"
import { Title, Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import paypalIcon from "assets/imagesV2/settings/paypal-logo.svg"
import { Button, Flex } from "antd"
import { spacings } from "themes/variables"
import { useDispatch, useSelector } from "react-redux"
import { connectPayPal, disconnectPayPal } from "store/payment-provider"
import PaypalStatus from "./PaypalStatus"
import { getUser, isPaypalConnectedSelector } from "store/user"

const PaypalAccountCard = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isPaypalConnectLoading = useSelector((state) => state.paymentProvider?.connectPayPal?.loading)
  const isPaypalDisconnectLoading = useSelector((state) => state.paymentProvider?.disconnectPayPal?.loading)
  const isPaypalConnected = useSelector(isPaypalConnectedSelector)

  useEffect(() => {
    dispatch(getUser())
  }, [dispatch])

  const handleConnectPayPal = async () => {
    const response = await dispatch(connectPayPal())
    if (response?.action_url) {
      window.location.replace(response.action_url)
    }
  }

  const handleDisconnectPayPal = async () => {
    await dispatch(disconnectPayPal())
    dispatch(getUser())
  }

  return (
    <Card className="mt-m">
      <Flex align="center" gap={spacings.S}>
        <img src={paypalIcon} alt="Paypal icon" width={50} />
        <Flex vertical gap={spacings.XS} flex={1}>
          <Title level={4}>{t("pro.settings.paypal.paypal_account")}</Title>
          <Text>{t("pro.settings.paypal.card_description")}</Text>
        </Flex>
        <PaypalStatus isPaypalConnected={isPaypalConnected} />
        <Button
          size="large"
          type="primary"
          onClick={isPaypalConnected ? handleDisconnectPayPal : handleConnectPayPal}
          loading={isPaypalConnectLoading || isPaypalDisconnectLoading}
          disabled={isPaypalConnectLoading || isPaypalDisconnectLoading}
        >
          {isPaypalConnected ? t("global.disconnect") : t("global.connect")}
        </Button>
      </Flex>
    </Card>
  )
}

export default PaypalAccountCard
